export default __webpack_public_path__ + "static/media/play-store-badge.70b70369.svg";